import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Mini Seedcamp Ljubljana finalists congratz",
  "description": "",
  "published": "2009-05-04T00:00:00.000Z",
  "redirect_from": ["/blog/mini-seedcamp-ljubljana-finalists-congratz/swizec/502"],
  "categories": "Entrepreneur, intrigues, Mini Seedcamp Ljubljana, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.crunchbase.com/company/seedcamp"
          }}><img parentName="a" {...{
              "src": "https://www.crunchbase.com/assets/images/resized/0000/0154/154v1-max-450x450.png",
              "alt": "Image representing Seedcamp as depicted in Cru...",
              "title": "Image representing Seedcamp as depicted in Cru..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://www.crunchbase.com"
          }}>{`CrunchBase`}</a></p>
      </li>
    </ul>
    <p>{`Today the `}<a parentName="p" {...{
        "href": "http://blog.seedcamp.com/2009/05/20-hopeful-teams-get-ready-to-embrace.html"
      }}>{`Mini Seedcamp Ljubljana finalists`}</a>{` have been announced and even though I'm unfortunately not amongst them I want to congratulate each and every one of them. You guys rock the business world's socks off ... apparently.`}</p>
    <p>{`It's difficult to say why each contestant was chosen, especially because I haven't taken a long enough look at the list, but it's quite obvious why my idea wasn't amongst them. Spelling out why the application hasn't worked out right now would probably bore you to death so I'll keep it short - too early.`}</p>
    <p>{`Yep, I was all giddy and happy about what I was working on and in the process, as has often happened before, failed to notice just at what an early stage it actually was. The main idea behind it, still not implemented, still no user base, nothing. Will definitely have to work on all of these points before I apply again and rest assured, I `}<strong parentName="p">{`will`}</strong>{` apply again.`}</p>
    <p>{`Except for the whole "You can only apply to one Mini Seedcamp event." on the application page. Anyone know what exactly this means? Am I screwed until the main Seedcamp in September?`}</p>
    <p>{`Anyhow, out of the finalists I must say the idea of `}<a parentName="p" {...{
        "href": "http://my.longurl.net"
      }}>{`longurl.net`}</a>{` seems best. Nice, simple, big user base and overall excelent for these things. People love simple.`}</p>
    <p>{`Once more, congratz guys, best of luck to you.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/ef2ccadf-bf65-47ce-89cf-058eb7ed1706/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=ef2ccadf-bf65-47ce-89cf-058eb7ed1706",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      